<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="免显设置" name="first">
        <NoDisplayProduct></NoDisplayProduct>
      </el-tab-pane>
      <el-tab-pane label="免补卡设置" name="second">
        <NoReplacementCard></NoReplacementCard>
      </el-tab-pane>
      <!-- 支付不展示手机号 -->
      <el-tab-pane label="支付免显手机号" name="three">
        <NoPhonePay></NoPhonePay>
      </el-tab-pane>
      <el-tab-pane label="领流量免显手机号" name="four">
        <NoPhoneFreeProduct></NoPhoneFreeProduct>
      </el-tab-pane>
      <el-tab-pane label="代理商支付账号配置" name="five">
        <AgentPay></AgentPay>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import NoDisplayProduct from "./NoDisplayProduct.vue";
import NoReplacementCard from "./NoReplacementCard.vue";
import NoPhonePay from "./NoPhonePay.vue";
import NoPhoneFreeProduct from "./NoPhoneFreeProduct.vue";
import AgentPay from "./AgentPay.vue";

export default {
  name: "AgentDict",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    NoDisplayProduct,
    NoReplacementCard,
    NoPhonePay,
    NoPhoneFreeProduct,
    AgentPay
  },
  created() {
  },
};
</script>